export default "__VITE_ASSET__b5aab252__"